import { buildOrgById } from './pathBuilder';
import { pathToLevelConfig } from './pathToLevelConfig';
import type { CycleDesignerFormState, DesignerPath, OrgPathNode } from '../types';

export function buildJsonPreview(
  form: CycleDesignerFormState,
  paths: DesignerPath[],
  orgNodes: OrgPathNode[],
  anchor: OrgPathNode | null,
): string {
  const orgById = buildOrgById(orgNodes);
  const config = {
    cycleName: form.cycleName,
    dateRange: { start: form.startDate, end: form.endDate },
    cycleType: form.cycleType,
    maxIterations: form.maxIterations,
    anchor: anchor
      ? { orgUnitId: anchor.id, name: anchor.name, title: anchor.title }
      : null,
    tracks: paths.map((path) => {
      const nodes = path.nodes.map((id) => orgById.get(id)).filter(Boolean);
      return {
        id: path.id,
        name: path.name,
        color: path.color,
        path: nodes.map((n) => ({
          id: n!.id,
          name: n!.name,
          relativeLevel: n!.relativeLevel,
        })),
        levelConfig: pathToLevelConfig(path, orgNodes, path.params),
        params: path.params,
      };
    }),
  };
  return JSON.stringify(config, null, 2);
}
